// extracted by mini-css-extract-plugin
module.exports = {"component":"capacitor-DownloadButton__component--3RTNs","isLoading":"capacitor-DownloadButton__isLoading--G6EnN","spinner":"capacitor-DownloadButton__spinner--1vh0O"};